export const SENDING_EMAIL_LOADING = 'SENDING_EMAIL_LOADING'
export const SENDING_EMAIL_SUCCESS = 'SENDING_EMAIL_SUCCESS'
export const SENDING_EMAIL_FAILED = 'SENDING_EMAIL_FAILED'